// extracted by mini-css-extract-plugin
module.exports = {"productWidgetLayout":"_3wWOC","contentArea":"_3WixR","productDetailsHideOnHover":"_1T_Er","actionButtonShowOnlyOnHover":"L_rv4"};